module.exports = __webpack_public_path__ + "img/blue-marine-1.be209df0.png";